import React, {useEffect,useState,useContext, Component} from 'react'
import { GlobalContext } from '../contexts/GlobalContext';
import {Message} from 'coaz-ui';
import client from '../client'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import MobileTransaction from './MobileTransaction';

const MobilePayment = () => {
    const {setLoading} = useContext(GlobalContext);
    const [tariff,setTariff] = useState(null);
    const [message,setMessage] = useState({content:'',success:false});
    const path = useLocation().pathname;
    const {request,errorMessage} = client;
    const navigate = useNavigate();

    const params = new URLSearchParams(window.location.search);

    const [phoneNumber,setPhoneNumber] = useState({
        part1:'260',
        part2:'',
        part3:'',
        part4:''
    });

    const onPhoneNumber = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let value = e.target.value;
        if(isNaN(value)) {
            return;
        }
        setPhoneNumber({...phoneNumber,[e.target.name]:value})
    }

    const close = () => {
        navigate(-1);
    }

    const onSubmit = async (number,amount) => {
        if(!tariff || !tariff.tariffable) {
            throw new Error("Invalid tariff");
        }
        setMessage({content:"",success:false});
        setLoading(true);

        if(!params || !params.get('userId') || !tariff) {
            setLoading(false);
            return;
        }
        
        return request('POST','payment/mobile',null,{
            userId:params.get('userId'),
            tariffableReference:tariff.tariffableReference,
            criteriaValue:tariff.criteriaValue,
            phoneNumber:number,
            narration:tariff.tariffable.name,
            sponsor:params.get('sponsor')?params.get('sponsor'):''
        })
    } 

    useEffect(() => {
        if(params && params.get('userId') && params.get('tariffableReference') && params.get('criteriaValue')) {
            request('GET','tariffs/by-id',null,{
                tariffableReference:params.get('tariffableReference'),
                criteriaValue:params.get('criteriaValue')
            })
            .then((response) => {
                if(response && response.tariffableReference) {
                    setTariff(response)
                } else {
                    setTariff(null);
                }
            })
            .catch((error) => {
                setTariff(null);
            })
        }
    },[path])

    return (
        <MobileTransaction onSubmit={onSubmit} staticAmount={tariff?tariff.price:0}/>
    )
}

export default MobilePayment

